import { MechanicValidatorKnight } from '@colonist/game-mechanic-validators';
import { useMemo } from 'react';
import { useGameStore } from '../GameStoreContext.ts';
import { useMapValidator } from './useMapValidator.ts';
import { usePlayerValidators } from './usePlayerValidators.ts';
export const useMechanicValidatorKnight = ()=>{
    const { playerValidators } = usePlayerValidators();
    const mapValidator = useMapValidator();
    const mechanicKnightState = useGameStore((state)=>state.gameState.mechanicKnightState);
    return useMemo(()=>{
        if (!mechanicKnightState) return undefined;
        return new MechanicValidatorKnight(playerValidators, mapValidator, mechanicKnightState);
    }, [
        playerValidators,
        mapValidator,
        mechanicKnightState
    ]);
};
